import { render, staticRenderFns } from "./ImageDimensionsRow.vue?vue&type=template&id=340792ce&scoped=true"
import script from "./ImageDimensionsRow.vue?vue&type=script&lang=js"
export * from "./ImageDimensionsRow.vue?vue&type=script&lang=js"
import style0 from "./ImageDimensionsRow.vue?vue&type=style&index=0&id=340792ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_f5b883aeb3d125b1f29ae1b8ca7c56aa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340792ce",
  null
  
)

export default component.exports